import { IUser, User } from '../../models/user';

/**
 * Authentication response object.
 */
export class AuthResponse {
    user: IUser;

    static toUser(response: AuthResponse): User {
        const user = new User();
        user.email = response.user.email;
        user.displayName = response.user.displayName;
        user.modules = response.user.modules;
        user.role = response.user.role;
        user.permissions = response.user.permissions;
        return user;
    }
}

export interface TLoginResponse {
    token: string;
}
export type LoginApiResponse =
    | { token: string }
    | { otp_required: true; message?: string }
    | { otp_enrollment_required: true; setup_url: string; message?: string };

// === What your service returns to the UI ===
export type LoginResult =
    | { kind: 'success'; user: IUser }
    | { kind: 'otp_required'; message?: string }
    | { kind: 'redirected_for_enrollment'; setup_url: string } // we already navigated away
    | { kind: 'error'; error: unknown };
